import { IndexCardStack } from './index-card-stack';
import { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { KoanIndexCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/index-cards-3x5/koan-index-card-stack-background/koan-index-card-stack-background.component';
import { KoanIndexCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/index-cards-3x5/koan-index-card-stack-content/koan-index-card-stack-content.component';

export class KoanIndexCardStack extends IndexCardStack {
  getCardHeightInInches(): number {
    return 3;
  }

  getCardWidthInInches(): number {
    return 4.24;
  }

  getCardBackgroundComponent(data: CardData): Type<CardBackgroundComponent> | null {
    return KoanIndexCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return KoanIndexCardStackContentComponent;
  }
}
